export default {
  NAVBAR_HEIGHT: '72px',
};
